import _classCallCheck from "/opt/build/repo/front/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import * as ReactDOM from "react-dom";
import * as React from "react";
import ToastManager from "./ToastManager";
var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined";
var PORTAL_ID = "react-toast";

var Toaster = function Toaster() {
  var _this = this;

  _classCallCheck(this, Toaster);

  this.bindNotify = function (fn) {
    _this.createNotification = fn;
  };

  this.notify = function (message) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (_this.createNotification) {
      _this.createNotification(message, options);
    }
  };

  if (!isBrowser) {
    return;
  }

  var portalElement;
  var existingPortalElement = document.getElementById(PORTAL_ID);

  if (existingPortalElement) {
    portalElement = existingPortalElement;
  } else {
    var el = document.createElement("div");
    el.id = PORTAL_ID;
    el.className = "Toaster";

    if (document.body != null) {
      document.body.appendChild(el);
    }

    portalElement = el;
  }

  ReactDOM.render(React.createElement(ToastManager, {
    notify: this.bindNotify
  }), portalElement);
};

export default Toaster;